<script>
  import {
    sitesComputed,
  } from '@state/helpers'

  export default {
    props: {
      images: {
        type: Array,
        required: true,
      }
    },
    computed: {
      ...sitesComputed,
      /**
       * @description Resolve the image object that we should be displaying:
       * @returns The first image in the array that is featured
       * @returns The first image in the array
       * @returns Null otherwise
       */
      displayableImage() {
        if (this.images && this.images.length > 0){
          this.images.forEach(image => {
            if (image.is_featured){
              return image
            }
          });
          return this.images[0]
        }
        return null
      },
      getLogo() {
        if (this.siteData && this.siteData.logo && this.siteData.logo.url){
          return this.siteData.logo.url
        }
        return null
      },
    },
    created() {
      if (!this.siteData) {
        this.resolveSiteData()
      }
    },
  }
</script>

<template>
  <section>
    <div v-if="displayableImage" class="ct-block image-content">
      <img
        :src="displayableImage.url"
        :alt="displayableImage.alt"
        class="image"
        style="max-width:100%" />
    </div>
    <div v-else class="ct-block image-content ">
      <img
        v-if="getLogo"
        :src="getLogo"
        alt="No available images"
        title="No available images"
        class="logo-icon" />
    </div>
  </section>
</template>
